import React, {useMemo} from 'react';
import {api} from 'utils/api-client';
import {useQuery, useQueryClient} from 'react-query';
import FullPageLoader from '../../gakki/components/FullPageLoader';

async function bootstrapAppData(props: any) {
  let user = null;
  try {
    const data = await api.get('backoffice/user');
    user = data.data;
  } catch (ex) {
    return user;
  }
  return user;
}

type AuthContextProps = {
  login: () => void
  logout: () => void
  user?: {name: string, email: string}
}

const AuthContext = React.createContext<AuthContextProps>({login: () => {}, logout: () => {}});
AuthContext.displayName = 'AuthContext';


export function AuthProvider(props: any) {
  const {isSuccess, isLoading, isIdle, data:user} = useQuery('user', bootstrapAppData);
  const client = useQueryClient();

  const login = React.useCallback(
    () => {
      window.location.href = '/MicrosoftIdentity/Account/SignIn';
    },
    [],
  );


  const logout = React.useCallback(async () => {
    await api.delete('backoffice/operator/session');
    client.clear();
    window.location.href = '/gakki-management';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const value = useMemo(() => ({user, login, logout}), [user, login, logout])

  if (isLoading || isIdle) {
    return <FullPageLoader/>
  }

  if (isSuccess) {
    return <AuthContext.Provider value={value} {...props} />;
  }
  throw new Error('something bad happen');
}

export function useAuth() {
  const context = React.useContext(AuthContext)
  if (context === undefined) {
    throw new Error(`useAuth must be used within a AuthProvider`)
  }
  return context
}
